import {routeReducer} from 'redux-simple-router';
import {ACTION_TYPE_STATE_MERGE} from '../base';
import {mergeObjects} from '../core/objects';
import {data} from './data';
import {ui} from './ui';

export function rootReducer(state, action) {
    if (action.type.startsWith(ACTION_TYPE_STATE_MERGE)) {
        return mergeObjects({}, action.mergeOptions || {},
                            state, action.newState);
    }
    else {
        return Object.assign({}, state,
            {ui: ui(state.ui, action)},
            {data: data(state.data, action)},
            {routing: routeReducer(state.routing, action)}
        );
    }
}
